import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { ApplicationArea } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'director-summary',
   templateUrl: './director-summary-page.component.html',
   styleUrls: ['./director-summary-page.component.scss'],
   standalone: false,
})
export class GrowthToolkitDirectorSummaryPage {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   constructor(private authMgr: AuthManager, private router: Router) {
      this.authMgr.getCurrentUser().subscribe((user) => {})
   }
}
